// Define the Web Component
class WaitlistForm extends HTMLElement {
  constructor() {
    super();
    // Attach Shadow DOM
    this.attachShadow({ mode: 'open' });

    // Initialize state
    this.emailAddress = '';
    this.waitlistFormResults = {
      status: false, // can be false, 'error', or 'success'
      message: '',
    };

    // Bind methods
    this.submitForm = this.submitForm.bind(this);
    this.closeQP = this.closeQP.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  // Specify observed attributes for props
  static get observedAttributes() {
    return ['current-variant', 'product-id', 'collection'];
  }

  // Handle attribute changes
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'current-variant') {
      try {
        this.currentVariant = JSON.parse(newValue);
      } catch (e) {
        console.error('Invalid JSON for current-variant:', newValue);
        this.currentVariant = null;
      }
    } else if (name === 'product-id') {
      this.productId = newValue;
    } else if (name === 'collection') {
      this.collection = newValue;
    }
  }

  // Connected Callback
  connectedCallback() {
    this.render();
  }

  // Render the component once
  render() {
    const style = `
      <style>
      #waitlist-form * {
        box-sizing: border-box;}
        .flex { display: flex; }
        .flex-col { flex-direction: column; }
        .w-full { width: 100%; }
        .p14 {
           font-size: 1.4rem;
           line-height: 1.2;
         }
        
        .mb-2\\.5 { margin-bottom: 10px; }
        .text-abc-grey-1 { color: #414042; }
        .placeholder-abc-grey-1::placeholder { color: #414042; }
        .border-abc-alert-red { border: 1px solid #b65151; }
        .border-abc-grey-3 { border: 1px solid #ccc; }
        .p18 { font-size: 1.8rem;
           line-height: 1.2; }
           a {
            width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
           }
        .button-primary {
          box-sizing: border-box;
          border-radius: 10000px;
  text-transform: uppercase;
  font-family: var(--font-heading-family);
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: .2rem;

        background-color: #ebd923;
          color: #003A5D;
          border: 2px solid #003A5D;
          cursor: pointer;
        }
          #email-input {
          height: 48px;
          padding: 8px 12px;
          margin-bottom: 10px;
          border-radius: 10000px;
          }
        .h-12 { height: 48px; }
        .text-3xl { font-size: 3rem; }
        .uppercase { text-transform: uppercase; }
        .text-abc-alert-red { color: #b65151; }
        .text-abc-downwinder-teal { color: #00afaa; }
        .h3 { font-size: 1.5rem; }
        .p { font-size: 1rem; }
        .mb-4 { margin-bottom: 16px; }
        .mb-3\\.5 { margin-bottom: 14px; }
        .text-center { text-align: center; }

        .sr-only-waitlist {
        position: absolute !important;
        width: 1px; height: 1px;
        padding: 0; margin: -1px;
        overflow: hidden; clip: rect(0,0,1px,1px);
        white-space: nowrap; border: 0;
      }
      </style>
    `;
    const template = `
    <form id="waitlist-form" class="flex flex-col w-full" novalidate>
      <!-- Screen-reader label (keeps WCAG happy without changing your layout) -->
      <label for="email-input" class="sr-only-waitlist">Email address</label>

      <input
        id="email-input"
        type="email"
        name="email"
        autocomplete="email"
        inputmode="email"
        placeholder="Enter email address..."
        class=" "
        required
        aria-label="Email address"
      >

      <!-- Live region for errors -->
      <p id="error-message" hidden role="alert" aria-live="assertive"
         class="p14 text-abc-alert-red mb-4"></p>

      <button type="submit" class="button-primary h-12 text-3xl uppercase">
        Notify me
      </button>
    </form>

    <div id="success-message" hidden class="w-full">
      <h3 id="success-title" tabindex="-1"
          class="h3 text-abc-downwinder-teal mb-2 text-center uppercase">
        Success!
      </h3>
      <p class="p18 text-center mb-3.5">
        We'll let you know as soon as it's back in stock
      </p>
      <a href="/collections/shop-all"
         class="button-primary w-full h-12 text-3xl uppercase">
        Continue Shopping
      </a>
    </div>
  `;

    this.shadowRoot.innerHTML = `${style}${template}`;

    // ...existing element refs...
    this.form = this.shadowRoot.getElementById('waitlist-form');
    this.emailInput = this.shadowRoot.getElementById('email-input');
    this.errorMessage = this.shadowRoot.getElementById('error-message');
    this.successMessage = this.shadowRoot.getElementById('success-message');
    // FIX: success control is a link, not a button
    this.successButton = this.shadowRoot.querySelector('#success-message a');

    // Add event listeners
    if (this.form) {
      this.form.addEventListener('submit', this.submitForm);
    }

    if (this.successButton) {
      this.successButton.addEventListener('click', this.closeQP);
    }

    if (this.emailInput) {
      this.emailInput.addEventListener('input', this.handleInputChange);
    }
  }

  // Handle input changes without re-rendering
  handleInputChange(event) {
    this.emailAddress = event.target.value;
    // Reset form results when email changes
    if (this.waitlistFormResults.status !== false) {
      this.waitlistFormResults.status = false;
      this.waitlistFormResults.message = '';
      this.updateInputState();
    }
  }

  // Update only the input and error message states
  updateInputState() {
    if (this.emailInput) {
      const isError = this.waitlistFormResults.status === 'error';

      // Toggle visual state
      if (isError) {
        this.emailInput.classList.add('border-abc-alert-red');
        this.emailInput.classList.remove('border-abc-grey-3');
      } else {
        this.emailInput.classList.remove('border-abc-alert-red');
        this.emailInput.classList.add('border-abc-grey-3');
      }

      // A11y state
      this.emailInput.setAttribute('aria-invalid', String(isError));
      if (isError) {
        this.emailInput.setAttribute('aria-describedby', 'error-message');
      } else {
        this.emailInput.removeAttribute('aria-describedby');
      }

      // Move focus to the field when an error occurs
      if (isError) this.emailInput.focus();
    }

    if (this.errorMessage) {
      const isError = this.waitlistFormResults.status === 'error';
      this.errorMessage.hidden = !isError;
      this.errorMessage.textContent = isError ? this.waitlistFormResults.message : '';
    }
  }

  // Update the success message visibility
  updateSuccessMessage() {
    if (this.form && this.successMessage) {
      const isSuccess = this.waitlistFormResults.status === 'success';
      this.form.hidden = isSuccess;
      this.successMessage.hidden = !isSuccess;

      if (isSuccess) {
        // Move focus to the success title so SR/keyboard users are informed
        const title = this.shadowRoot.getElementById('success-title');
        if (title) title.focus();
      }
    }
  }
  // Close Quick Panel (dispatch a custom event)
  closeQP() {
    this.dispatchEvent(new CustomEvent('toggle-qp', { bubbles: true, composed: true }));
  }

  // Submit form handler
  async submitForm(event) {
    event.preventDefault();
    // Validate email
    if (!this.emailAddress || !this.validateEmail(this.emailAddress)) {
      this.waitlistFormResults.status = 'error';
      this.waitlistFormResults.message = 'Please enter a valid email address.';
      this.updateInputState();
      return;
    }

    try {
      this.waitlistFormResults.status = false;
      this.waitlistFormResults.message = '';
      this.updateInputState();

      // Prepare payload
      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: this.emailAddress,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${this.currentVariant.id}`,
              },
            },
          },
        },
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-06-15',
        },
        body: JSON.stringify(payload),
      };

      const response = await fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=L9VHwL',
        requestOptions
      );
      //console.log({ response });
      //console.log('Response OK:', response.ok);

      if (response.ok) {
        const contentLength = response.headers.get('Content-Length');
        const data = contentLength && parseInt(contentLength) > 0 ? await response.json() : {};

        if (data.errors && data.errors.length > 0) {
          const error = data.errors[0];
          this.waitlistFormResults.status = 'error';
          this.waitlistFormResults.message = `${error.title}: ${error.detail}`;
        } else {
          this.waitlistFormResults.status = 'success';
        }
      } else {
        throw new Error('Network response was not ok');
      }
    } catch (err) {
      console.error(err);
      this.waitlistFormResults.status = 'error';
      this.waitlistFormResults.message =
        'Something went wrong; please refresh the page and try again.';
    } finally {
      if (this.waitlistFormResults.status === 'success') {
        this.updateSuccessMessage();
      } else {
        this.updateInputState();
      }
    }
  }

  // Simple email validation
  validateEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }
}

// Register the Web Component
customElements.define('waitlist-form', WaitlistForm);
